export enum SmartsheetAttachmentAction {
  PlaceToRow = 'Row',
  PlaceToSheet = 'Sheet',
}
